<template>
  <div class="row">
    <div>Total MCQs: {{ maxLength }}</div>
    <div>Total Points : {{ totalPoints }}</div>
    <button
      v-if="currentIndex !== 0"
      class="button-black"
      @click="goToPreviousQuestion"
    >
      Previous
    </button>
    <button
      v-if="currentIndex !== maxLength - 1"
      class="button-black"
      @click="goToNextQuestion"
    >
      Next
    </button>

    <div class="small-12 columns">
      <div class="stitched-mcq-editor-main-container">
        <div class="mcq-question-title-container markdown-body">
          <vue-markdown
            :source="
              decodeAndRenderMarkdown(
                question.list.questions[currentIndex].title,
                question.attachments
              )
            "
          />
        </div>
        <div style="padding-bottom:20px;">
          points on this questions:
          {{ questions.list.questions[currentIndex].points }}
        </div>

        <div>
          <div
            v-for="(option, idx) in questions.list.questions[currentIndex]
              .options"
            :key="`option_${idx}`"
            class="mcq-stitched-option-container link"
            :class="applyClassesToOptions(option)"
            @click="selectOption(option)"
          >
            <vue-markdown
              :source="decodeAndRenderMarkdown(option.item, option.attachments)"
            />
          </div>
        </div>
      </div>
      <div><button @click="sampleEvaluateQuestion">Evaluate</button></div>
    </div>
  </div>
</template>

<script>
import VueMarkdown from "vue-markdown"
import siteConfig from "@/utils/siteConfig"

export default {
  components: { VueMarkdown },
  data() {
    return {
      questions: [],
      question: {},
      currentIndex: 0,
      maxLength: 0,
      selectedOptions: [],
      totalPoints: [],
    }
  },
  mounted() {
    this.getQuestionData()
  },
  methods: {
    sampleEvaluateQuestion() {
      const question = this.questions.list.questions[this.currentIndex]
      const attemptingQuestionID = question.question_id
      const mainQuestionID = this.question.id

      const userResponses = []

      const answerObj = {}
      answerObj.answer_ids = this.selectedOptions
      answerObj.question_id = attemptingQuestionID

      userResponses.push(answerObj)
      //
      // //////

      this.axios({
        method: "post",
        url: `${siteConfig.siteURL}questions/${mainQuestionID}/evaluate/mcq/evaluate`,
        headers: {
          "Content-Type": "application/json",
          Accept: "application/json",
          "x-access-token": localStorage.token,
        },
        data: { user_responses: [userResponses[0]] },
      }).then(res => {
        alert(res.data.data[0].is_correct)
      })
    },
    applyClassesToOptions(option) {
      const { id } = option
      const classes = []
      if (this.checkIfArrayPartofAnswers(id)) {
        classes.push("mcq-stitched-option-selected")
      }
      return classes.join(" ")
    },
    removeOptionFromSelectedOptions(optionID) {
      const index = this.selectedOptions.indexOf(optionID)
      if (index > -1) {
        this.selectedOptions.splice(index, 1)
      }
    },
    selectOption(option) {
      if (this.checkIfArrayPartofAnswers(option.id)) {
        this.removeOptionFromSelectedOptions(option.id)
      } else {
        this.selectedOptions.push(option.id)
      }
    },
    checkIfArrayPartofAnswers(element) {
      for (let i = 0; i < this.selectedOptions.length; i++) {
        if (this.selectedOptions[i] === element) {
          return true
        }
      }
      return false
    },
    goToPreviousQuestion() {
      this.selectedOptions = []
      if (this.currentIndex > 0) {
        this.currentIndex--
      }
    },
    goToNextQuestion() {
      this.selectedOptions = []
      if (this.currentIndex < this.maxLength - 1) {
        this.currentIndex++
      }
    },
    decodeAndRenderMarkdown(content, attachments) {
      window.Prism.highlightAll()
      this.$nextTick(() => {
        window.Prism.highlightAll()
      })

      return content.replace(/(\[\[.*?\]\])/g, item => {
        for (let i = 0; i < attachments.length; i++) {
          if (attachments[i].id === item.slice(2, item.length - 2)) {
            return ` ![](${attachments[i].public_url})`
          }
        }
        return ""
      })
    },
    getQuestionData() {
      this.axios({
        method: "get",
        url: `${siteConfig.siteURL}questions/${this.$route.params.id}`,
        headers: {
          "Content-Type": "application/json",
          Accept: "application/json",
          "x-access-token": localStorage.token,
        },
      }).then(res => {
        this.questions = res.data.data
        this.question = res.data.data
        this.maxLength = this.questions.list.questions.length

        this.totalPoints = 0
        for (let i = 0; i < this.questions.list.questions.length; i++) {
          this.totalPoints += this.questions.list.questions[i].points
        }
      })
    },
  },
}
</script>

<style>
.mcq-stitched-option-selected {
  border-left: 16px solid #82ff82 !important;
}
.mcq-stitched-option-container {
  margin-bottom: 8px;
  padding: 10px;
  padding-left: 20px;
  border-left: 16px solid transparent;
  font-family: "Gudea", sans-serif;
}
.mcq-question-title-container {
  padding: 20px;
  color: #03a9f4;
  font-family: "Gudea", sans-serif;
  font-size: 1.4em;
  text-align: left;
}
.stitched-mcq-editor-main-container {
  width: 800px;
  margin: auto;
  margin-top: 40px;
  padding: 40px;
  border: 1px solid black;
}
img {
  display: block;
  width: 100%;
  height: auto;
}
</style>
